<app-dialog-base [titleTranslationKey]="data.titleT">
    <ng-container content>
        <form [formGroup]="userForm">
            <div>
                <mat-form-field color="accent" class="full-width">
                    <mat-label>{{ 'users.select-user-form.name' | translate }}</mat-label>
                    <app-autocomplete-input formControlName="user" [options]="data.availableUsers"
                        [getDisplayName]="getUserDisplayName" required />
                    <mat-error *ngIf="userForm.get('user')!.hasError('required')">
                        {{ 'users.select-user-form.name-required' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </form>
    </ng-container>

    <ng-container actions>
        <div class="button-group">
            <app-button-cancel (click)="cancel()" />
            <app-button-save [disabled]="!userForm.valid" (click)="confirm()" />
        </div>
    </ng-container>
</app-dialog-base>
